export default __webpack_public_path__ + "static/slider-img-7de89cb9baf5be8d5664a6642758c8c3.png";